import { createContext } from "react";
import { StepType } from "../pages/auth/signup/steps/types";
import { TwoCompanySearchResponseType } from "@sellar-io/api-v2/types";

export type SignupFlowSteps =
  | "EmailStep"
  | "AboutStep"
  | "SignInStep"
  | "ForgotPasswordStep"
  | "MagicLinkSendStep"
  | "SignupDetails"
  | "BuyerCreationStep"
  | "OptInMarketingStep"
  | "BusinessSelectStep"
  | "ConfirmationStep"
  | "CreditEligibleStep";

export interface SignUpFlowStepType extends StepType {
  name: SignupFlowSteps;
  backStep?: SignupFlowSteps;
}

export type SignupContextType = {
  step?: SignUpFlowStepType;
  setStep: (step: SignUpFlowStepType) => void;
  signupDialogActive: boolean;
  setSignupDialogActive: React.Dispatch<React.SetStateAction<boolean>>;
  showLoginTitle: boolean;
  setShowLoginTitle: (showLoginTitle: boolean) => void;
  endOnboarding: () => void;
  // Basket total is needed at the moment as the sign up dialog has to be outside of the basket context
  // For loading reasons from App.tsx
  basketTotal: number | undefined;
  setBasketTotal: (basketValue: number | undefined) => void;
  buyerSelectBusinessId: number | undefined;
  setBuyerSelectBusinessId: (buyerSelectBusinessId: number | undefined) => void;
  redirectToMarket: boolean;
  setRedirectToMarket: (redirectToMarket: boolean) => void;
  redirectToSellarCreditOnboarding: boolean;
  setRedirectToSellarCreditOnboarding: (
    redirectToSellarCreditOnboarding: boolean,
  ) => void;
  hasAcceptedTermsAndConditions: boolean;
  setHasAcceptedTermsAndConditions: (
    hasAcceptedTermsAndConditions: boolean,
  ) => void;
  company: TwoCompanySearchResponseType[number] | null;
  setCompany: (company: TwoCompanySearchResponseType[number] | null) => void;
  creditLimitQuoteValue: number;
  setCreditLimitQuoteValue: (value: number) => void;
  buyerSignUpBusinessId: number | undefined;
  setBuyerSignUpBusinessId: (value: number) => void;
};

export const SignupContext = createContext<SignupContextType | undefined>(
  undefined,
);
